export const symbols = [
    {
        index: 0,
        id: "S",
        payouts: {
            5: 0,
            4: 0,
            3: 0
        },
        anticipation: 2,
        reels: [ 2, 3 ],
        matchesMin: 2,
        matchesMax: 3,
        bonusId: 1
    },
    {
        index: 1,
        id: "W",
        payouts: {
            5: 0,
            4: 0,
            3: 0
        }
    },
    {
        index: 2,
        id: "C",
        payouts: {
            5: 0,
            4: 0,
            3: 0
        }
    },
    {
        index: 3,
        id: "QH",
        payouts: {
            5: 0,
            4: 0,
            3: 0
        }
    },
    {
        index: 4,
        id: "L1",   // A
        payouts: {
            3: 20 / 25,
            4: 60 / 25,
            5: 200 / 25
        }
    },
    {
        index: 5,
        id: "L2",   // K
        payouts: {
            3: 18 / 25,
            4: 50 / 25,
            5: 150 / 25
        }
    },
    {
        index: 6,
        id: "L3",   // Q
        payouts: {
            3: 15 / 25,
            4: 30 / 25,
            5: 100 / 25
        }
    },
    {
        index: 7,
        id: "L4",   // J
        payouts: {
            3: 10 / 25,
            4: 25 / 25,
            5: 80 / 25
        }
    },
    {
        index: 8,
        id: "L5",   // 10
        payouts: {
            3: 7 / 25,
            4: 20 / 25,
            5: 60 / 25
        }
    },
    {
        index: 9,
        id: "H1",   // Red Tiger
        payouts: {
            2: 70 / 25,
            3: 100 / 25,
            4: 400 / 25,
            5: 2000 / 25
        }
    },
    {
        index: 10,
        id: "H2",   // Golden Tiger
        payouts: {
            3: 60 / 25,
            4: 200 / 25,
            5: 800 / 25
        }
    },
    {
        index: 11,
        id: "H3",   // White Tiger
        payouts: {
            3: 40 / 25,
            4: 150 / 25,
            5: 600 / 25
        }
    },
    {
        index: 12,
        id: "H4",   // Woman
        payouts: {
            3: 30 / 25,
            4: 100 / 25,
            5: 400 / 25
        }
    },
    {
        index: 13,
        id: "H5",   // Blue Tiger
        payouts: {
            3: 25 / 25,
            4: 80 / 25,
            5: 300 / 25
        }
    },
    {
        index: 14,
        id: "H1_14",
        height: 4,
        alwaysOnTop: true,
        payouts: {
            2: 7 / 25,
            3: 100 / 25,
            4: 400 / 25,
            5: 2000 / 25
        }
    },
    {
        index: 15,
        id: "H1_13",
        height: 3,
        alwaysOnTop: true,
        payouts: {
            2: 7 / 25,
            3: 100 / 25,
            4: 400 / 25,
            5: 2000 / 25
        }
    },
    {
        index: 16,
        id: "H1_12",
        height: 2,
        alwaysOnTop: true,
        payouts: {
            2: 7 / 25,
            3: 100 / 25,
            4: 400 / 25,
            5: 2000 / 25
        }
    },
    {
        index: 17,
        id: "QH+MINI",
        payouts: {
            5: 0,
            4: 0,
            3: 0
        },
        anticipation: 1,
        reels: [ 4 ],
        matchesMin: 1,
        matchesMax: Infinity
    },
    {
        index: 18,
        id: "QH+MINOR",
        payouts: {
            5: 0,
            4: 0,
            3: 0
        },
        anticipation: 1,
        reels: [ 4 ],
        matchesMin: 1,
        matchesMax: Infinity
    },
    {
        index: 19,
        id: "QH+MAJOR",
        payouts: {
            5: 0,
            4: 0,
            3: 0
        },
        anticipation: 1,
        reels: [ 4 ],
        matchesMin: 1,
        matchesMax: Infinity
    },
    {
        index: 20,
        id: "QH+GRAND",
        payouts: {
            5: 0,
            4: 0,
            3: 0
        },
        anticipation: 1,
        reels: [ 4 ],
        matchesMin: 1,
        matchesMax: Infinity
    }
];
